import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { WinLossModel } from "../../models/WinLossModel";
import WinLossService from "../../services/WinLossService";
import WinLossSlice from "../slices/WinLossSlice";
import { RootState } from "../store";

export const Actions = WinLossSlice.actions;
export const fetchProjectBidStatusHistory = (
  projectId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response: WinLossModel[] =
      await WinLossService.getProjectBidStatusHistory(projectId);
    dispatch(Actions.setBidStatusHistory(response));
  };
};
